import { useMutation } from '@tanstack/react-query'
import { thunkCheckVerifyToken } from 'app/authSlice'
import ToastHelper from 'general/helpers/ToastHelper'
import UserHelper from 'general/helpers/UserHelper'
import useRouter from 'hooks/useRouter'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

export default function SSO() {
  //   get params in router
  const [searchParams] = useSearchParams()
  const accessToken = searchParams.get('access_token')
  // const partner = searchParams.get('partner')
  const { navigate } = useRouter()

  const dispatch = useDispatch()

  const handleVerifyToken = useMutation({
    mutationKey: ['auth', 'signIn'],
    mutationFn: (params) => {
      return dispatch(thunkCheckVerifyToken({ ...params }))
    },
    onSuccess: ({ payload }) => {
      if (payload) {
        console.log({ payload })
        const displayName = UserHelper.getDisplayName(payload.metadata?.account)
        ToastHelper.showSuccess(`Xin chào, ${displayName}`)
        navigate('/ban-lam-viec', {
          replace: true,
        })
      }
    },
  })

  const verifyToken = async (accessToken) => {
    try {
      handleVerifyToken.mutate({ accessToken })
    } catch (error) {
      ToastHelper.showError('Đăng nhập thất bại!')
      navigate('/dang-nhap')
    }
  }
  useEffect(() => {
    if (!accessToken) {
      navigate('/dang-nhap')
    } else {
      verifyToken(accessToken)
    }
  }, [])
  return <></>
}
